import React, { getGlobal } from "reactn";
import ApiResponseError from "./ApiResponseError";

import History from '../navigator/history';
import Storage from 'react-native-storage';
import ApmService from '../services/Apm';
import Utils from "../lib/Utils";

const storage = new Storage({
  size: 1000,
  storageBackend: window.localStorage
});

const BASE_URL = process.env.BASE_API_DOCKER || process.env.BASE_API;

const getApiToken = () => {
  if (getGlobal().user && getGlobal().user.api_token)
    return getGlobal().user.api_token;
  return '';
}

const getHeaders = () => {
  return new Headers({
    'Content-Type': 'application/json',
    'Authorization': getApiToken(),
  });
}

const validateUnauthorized = async (response) => {
  // Reload page if return user unauthorized error (code 2).
  if (response.code == 2) {
    try {
      await storage.remove({ key: 'token' });
    }
    catch (error) {
      ApmService.noticeError({message: 'TOKEN NOT FOUND ON STORAGE'}, error)
      console.log('Token not found on storage')
    }
    History.go(0)
  }

  return response;
}

const Api = {
  get: async (resource, params = {}) => {
    let type = 'json';
    if (params.type) {
      type = params.type
      delete params.type
    }
    let querystring = Utils.jsonToQueryString(params);
    try {
      const response = await fetch(BASE_URL + resource + querystring, {
        method: 'get',
        headers: getHeaders(),
      });

      if (!response.ok) {
        let json = await response.json();
        validateUnauthorized(json)
        throw new ApiResponseError(response, json);
      }

      if (type == "json") {
        return await response.json()
      }
      if (type == "blob") {
        return await response.blob()
      }
    } catch (error) {
      ApmService.noticeError({message: 'ERROR ON GET CALL'}, error)
      return {
        error: error
      }
    }
  },
  post: async (resource, body, type = "json") => {
    try {
      const response = await fetch(BASE_URL + resource, {
        method: 'post',
        headers: getHeaders(),
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        let json = await response.json();
        validateUnauthorized(json)
        throw new ApiResponseError(response, json);
      }

      if (type == "json") {
        return await response.json()
      }
      if (type == "blob") {
        return await response.blob()
      }
    } catch (error) {
      ApmService.noticeError({message: 'ERROR ON POST CALL'}, error)
      return {
        error: error
      }
    }
  },
  put: async (resource, body) => {
    try {
      const response = await fetch(BASE_URL + resource, {
        method: 'put',
        headers: getHeaders(),
        body: JSON.stringify(body),
      });
      if (!response.ok) {
        let json = await response.json();
        validateUnauthorized(json)
        throw new ApiResponseError(response, json);
      }

      return await response.json();
    } catch (error) {
      ApmService.noticeError({message: 'ERROR ON PUT CALL'}, error)
      return {
        error: error
      }
    }
  },
  delete: async (resource) => {
    try {
      const response = await fetch(BASE_URL + resource, {
        method: 'delete',
        headers: getHeaders(),
      });

      if (!response.ok) {
        let json = await response.json();
        validateUnauthorized(json)
        throw new ApiResponseError(response, json);
      }

      return await response.json();
    } catch (error) {
      ApmService.noticeError({message: 'ERROR ON DELETE CALL'}, error)
      return {
        error: error
      }
    }
  }
};

const _Api = (BASE_URL) => { return `{ get: async (resource) => { const response = await fetch('${BASE_URL}' + resource, { method: 'get', headers: new Headers({ 'Authorization': '${getApiToken()}', }), }); const data = await response.json(); return data; }, post: async (resource, body) => { const response = await fetch('${BASE_URL}' + resource, { method: 'post', headers: new Headers({ 'Content-Type':'application/json', 'Authorization': '${getApiToken()}', }), body: JSON.stringify(body), }); const data = await response.json(); return data; }, put: async (resource, body) => { const response = await fetch('${BASE_URL}' + resource, { method: 'put', headers: new Headers({ 'Content-Type':'application/json', 'Authorization': '${getApiToken()}', }), body: JSON.stringify(body), }); const data = await response.json(); return data; }, delete: async (resource) => { const response = await fetch('${BASE_URL}' + resource, { method: 'delete', headers: new Headers({ 'Authorization': '${getApiToken()}', }), }); const data = await response.json(); return data; } }` };

export {
  Api,
  BASE_URL,
  _Api
};
